<template>
  <th
    :style="
      end == Object.keys(data).pop() || value == Object.keys(data).pop()
        ? { 'text-align': 'right' }
        : { 'text-align': 'left' }
    "
    :colspan="
      end == Object.keys(data).pop() || value == Object.keys(data).pop() ? 2 : 1
    "
    v-html="isNaN(value) ? clearCase(value) : value"
  />
</template>
<script>
import helper from "@/assets/js/helper.js";
export default {
  mixins: [helper],
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    end: { default: -1 },
    value: { default: "testing" },
  },
};
</script>